import React from 'react'
import TermsnconDocs from './TermsnconDocs'

export default function FooterGtc(props) {
    return (
        <React.Fragment>
            <div id="footer-gtc" className="overlay" style={{ display: 'flex' }}>
                <div className="mob-pop-about">

                    <TermsnconDocs handlepolicy={props.handlepolicy} />

                </div>
            </div>
        </React.Fragment>
    )
}
